import { DataModel } from '../../dto/dto.js';

export abstract class FileReferenceBase extends DataModel {
  abstract get uniqueId(): string;
  abstract get storagePath(): string;
  abstract get downloadUrl(): string;
}
